/**
 * Canonical current-app theme surface. These are Tailwind-theme-aligned CSS variable
 * overrides that define what "current" means for runtime UI.
 */
export const YSTNJ_CURRENT_THEME_TAILWIND_OVERRIDES = {
  '--color-primary': '#2697a2',
  '--color-primary-hover': '#08bfae',
  '--color-irongrey': '#404f4d',
  '--color-strawberry': '#fe2c3b',
  '--color-coral': '#ff5f5f',
  '--color-vibrant-coral': '#ff5f5f',
  '--color-aquamarine': '#28e2a7',
  '--color-jungle': '#237062',
  '--color-background-light': '#f8faf9',
  '--color-surface-light': '#ffffff',
  '--color-border': '#e5e7eb',
  '--color-border-strong': '#d1d5db',
  '--color-muted': '#f4f6f3',
  '--color-text-secondary': '#6b7280',
  '--color-text-tertiary': '#9ca3af',
  '--color-success-background': '#e6faf3',
  '--color-info-background': '#e8f5f7',
  '--color-warning-background': '#fff0f0',
  '--color-error-background': '#ffe8f0',
  '--primary': 'var(--color-primary)',
  '--primary-hover': 'var(--color-primary-hover)',
  '--iron-grey': 'var(--color-irongrey)',
  '--strawberry': 'var(--color-strawberry)',
  '--coral': 'var(--color-coral)',
  '--aquamarine': 'var(--color-aquamarine)',
  '--jungle': 'var(--color-jungle)',
  '--background-light': 'var(--color-background-light)',
  '--surface-light': 'var(--color-surface-light)',
  '--border': 'var(--color-border)',
  '--border-strong': 'var(--color-border-strong)',
  '--muted': 'var(--color-muted)',
  '--text-secondary': 'var(--color-text-secondary)',
  '--text-tertiary': 'var(--color-text-tertiary)',
  '--success-background': 'var(--color-success-background)',
  '--info-background': 'var(--color-info-background)',
  '--warning-background': 'var(--color-warning-background)',
  '--error-background': 'var(--color-error-background)',
  '--font-sans': "'Albert Sans', sans-serif",
  '--font-heading': "'Mulish', sans-serif",
} as const satisfies Record<string, string>;
